import { Component, Input,OnInit } from '@angular/core';
import {ActivatedRoute,Router} from '@angular/router';
import { CourseCatalogService } from '../../learner/my-tasks/course-catalog.service';
import { BaseService } from '../../shared-service/base.service';

declare var $: any;
@Component({
  selector: 'app-learning-card-all',
  templateUrl: './learning-card-all.component.html',
  styleUrls: ['./learning-card-all.component.css']
})
export class LearningCardAllComponent implements OnInit {
  @Input() LearningCardAll: Object[]|any;
  public ItemDetail: any;  
  public Item: Array<Object> | any = [];
  isPlay: boolean = false;
  constructor(private router:Router,private route:ActivatedRoute,private courseCatalogService: CourseCatalogService,public bs:BaseService) { }

  ngOnInit() {
    this.ItemDetail= this.LearningCardAll;

    $(".course").hover(function(){
      // $(this).find(".progress-bar-main").css({"display": "none"});
      $(this).find(".icons .select").animate({bottom: "0"},0.1);
      $(this).find(".icons .add").animate({bottom: "0"},0.1);
      // $(this).find(".icons .select").animate({bottom: "0"},0.1);
      // $(this).find(".icons .share").animate({bottom: "0"},0.1);
      // $(this).find(".icons .report").animate({bottom: "0"},0.1);
  });

    $(".course").mouseleave(function(){
      // $(".progress-bar-main").css({"display": "block"});
      $(".icons .select").css({"bottom": "-100px"});
      $(".icons .add").css({"bottom": "-100px"});
      
      // $(".icons .select").css({"bottom": "-100px"});
      // $(".icons .share").css({"bottom": "-100px"});
      // $(".icons .report").css({"bottom": "-100px"});
      $(".icons .select").css({"display": "block"});
      $(".icons .add").css({"display": "block"});
   });
  }

  openLearningDetail(learning:any, flag:any) {
    let params = {
      tab: '',
      id: learning.CourseID
    }

    if (learning['CourseType'] == 'T') {
      this.router.navigate(['/learner/taskList/container/catalog-ilt-detail', { tab: '', id: learning['ILTID'], cns: learning['CNS'] }]);
    }
    else {
      this.router.navigate(['/learner/taskList/container/catalog-detail', { tab: '', id: learning['CourseID'] }]);
    }

  }

  openCatalogDetail(course: any,current:any) {
    if (course['LearningType'] == 'T') {
      this.router.navigate(['/learner/course-catalog/container/catalog-ilt-detail', { tab: '', id: course['ILTID'], cns: course['CNS'] }]);
    }
    else {
      if(current == 'Rating'){
      this.router.navigate(['/learner/course-catalog/container/catalog-detail', { tab: 'Rating', id: course['CourseID'] }]);
      this.courseCatalogService.courseGamficationPoints = course['GamificationPoints'];
      }
      else{
        this.router.navigate(['/learner/course-catalog/container/catalog-detail', { tab: '', id: course['CourseID'] }]);
        this.courseCatalogService.courseGamficationPoints = course['GamificationPoints'];
      }

    }
  }



  routeTo(path: string, params: object) {
    this.router.navigate([path, params]).then((res) => {
      console.log(res);
    });
  }

  addToJourney(learningDetails:any)
  {
      this.courseCatalogService.interestedIdList=[];
      this.courseCatalogService.courseId=learningDetails["CourseID"];
      this.courseCatalogService.learningType=learningDetails["LearningType"];
        console.log(learningDetails);
        $("#popBody").find("tr").each(function(){
          $(this).removeClass("active");
        });
  }

  
  showGamificationRule(id: string) {
    this.Item.push({ 'id': id })
    this.loadGamificationRule(id);
    $('.hideDiv').hide();
    $('#divGmfctnRlFrCtlg' + id).show();
  }

  loadGamificationRule(id: string) {
    for (var i = 0; i < this.Item.length; i++) {
      if (this.Item[i]['id'] == id) {
        return true;
      }
    }
    return false;
  }

}
